export default {
  SEQUENCE: "sortBy_sequence",
  DATE: "sortBy_date",
  NARRATIVE: "sortBy_narrative",
  LABEL: "sortBy_label",
  IDENTIFIER: "sortBy_identifier"
};
